(function(factory) {
	if(typeof define === 'function' && define.amd) {
		define(['jquery'], factory);
	} else if(typeof module === 'object' && module.exports) {
		module.exports = function(root, jQuery) {
			if(jQuery === undefined) {
				if(typeof window !== 'undefined') {
					jQuery = require('jquery');
				} else {
					jQuery = require('jquery')(root);
				}
			}
			factory(jQuery);
			return jQuery;
		};
	} else {
		factory(jQuery);
	}
}(function($) {
	'use strict';

	$.fn.animateCSS = function(animation) {
		var options = {};

		if(typeof arguments[1] === 'object') {
			options = arguments[1];
		} else if(typeof arguments[1] === 'function') {
			options.complete = arguments[1];
		} else if(typeof arguments[1] === 'number') {
			options.duration = arguments[1];
			if(typeof arguments[2] === 'function') options.complete = arguments[2];
		}

		options = $.extend(true, {
			animation: animation,
			complete: function() {},
			delay: 0,
			duration: 1000
		}, options);

		$(this).each(function() {
			var el = this;

			if(options.duration) {
				$(el).css({
					'-moz-animation-duration': options.duration + 'ms',
					'-o-animation-duration': options.duration + 'ms',
					'-webkit-animation-duration': options.duration + 'ms',
					'animation-duration': options.duration + 'ms'
				});
			}

			if(options.delay <= 0) {
				animateCSS(el, options).then(r => options.complete.call(el));
			} else {
				setTimeout(function() {
					animateCSS(el, options).then(r => options.complete.call(el));
				}, options.delay);
			}
		});

		return this;
	};
}));

const animateCSS = (element, options) => {
	if(typeof options === 'string') {
		let animation = options;
		options = {};

		options.animation = animation;
	}

	return new Promise((resolve, reject) => {
		var animationEnd = 'animationend mozAnimationEnd MSAnimationEnd oanimationend webkitAnimationEnd';

		const animationName = `${animate_prefix}${options.animation}`;
		const node = $(element);

		node.addClass(`${animate_prefix}animated ${animationName}`);

		node.on(animationEnd, () => {
			node.off(animationEnd);
			node.removeClass(`${animate_prefix}animated  ${animationName}`);

			resolve('Animation ended');
		});
	});
};
